import {
  IconMyInfos,
  IconMyOrders,
  IconMyReturn,
  IconMyPref,
  IconMyFilleuls,
  IconFaqs,
  IconPrivilege,
  IconMailMenu,
} from 'Ui/Icons';
import { Personna, HomeNew, InfoV2, Logout, BonAchat } from 'Ui/Icons/icons';
import { logout } from 'Utils/isLogout';
import {
  Header,
  HeaderMaincontainer,
  HeaderLogoContainer,
  WelcomeMember,
  LinkLine,
  NeedHelp,
  HeaderBackgroundMobileConnected,
} from './style';
import AuthStore from 'Store/AuthStore';
import UiStore from 'Store/UiStore';
import { useApolloClient, useQuery } from '@apollo/client';
import { isAndroid } from 'react-device-detect';
import styled from 'styled-components';
import { getBasket } from 'Components/Header/HeaderBasket/__generated__/getBasket';
import query from 'Components/Header/HeaderBasket/query';
import { useTranslation } from 'react-i18next';

const LinksContainer = styled.div`
  display: flex;
  height: calc(100% - 10.6rem);
  justify-content: space-between;
  flex-direction: column;
  padding: 0 0 1.5rem;
  overflow-y: scroll;
`;

export const SideMenuMember = () => {
  const setAuth = AuthStore.useStoreActions((actions) => actions.setAuth);
  const sideMenuOpen = UiStore.useStoreState((state) => state.sideMenuOpen);
  const setSideMenuOpen = UiStore.useStoreActions(
    (actions) => actions.setSideMenuOpen
  );
  const member = AuthStore.useStoreState((state) => state.member);
  const apolloClient = useApolloClient();
  const linkDownload = isAndroid
    ? '/home/app/p/android/source/interstitiel/'
    : '/home/app/p/ios/source/interstitiel/';
  const { t } = useTranslation('header', { useSuspense: false });
  const headerTranslate = {
    greetings: t('greetings'),
    myOrders: t('myOrders'),
    myAccount: t('myAccount'),
    myReturns: t('myReturns'),
    myVouchers: t('myVouchers'),
    help: t('help'),
    preferencesCenter: t('preferencesCenter'),
    mobileApp: t('mobileApp'),
    referral: t('referral'),
    disconnect: t('disconnect'),
  };
  const { refetch } = useQuery<getBasket>(query);
  return (
    <>
      <Header>
        <HeaderBackgroundMobileConnected>
          <HeaderMaincontainer>
            <WelcomeMember>
              {headerTranslate.greetings} {member && member.firstName}
            </WelcomeMember>
          </HeaderMaincontainer>
        </HeaderBackgroundMobileConnected>
      </Header>
      <LinksContainer>
        <div>
          <LinkLine
            text={headerTranslate.myOrders}
            src="/commandes/index/"
            icon={<IconMyOrders />}
            hasBorder={false}
            withIcon={false}
            hasMarginTop={true}
          />
          <LinkLine
            text={headerTranslate.myAccount}
            src="/account/index/"
            icon={<IconMyInfos />}
            hasBorder={false}
            withIcon={false}
          />
          <LinkLine
            text={headerTranslate.myReturns}
            src="/account/retours/"
            icon={<IconMyReturn />}
            hasBorder={false}
            withIcon={false}
          />
          <LinkLine
            text={headerTranslate.help}
            src="/contact/"
            icon={<IconFaqs />}
            hasBorder={false}
            withIcon={false}
          />
          <LinkLine
            text={headerTranslate.preferencesCenter}
            src="/account/newsletters/"
            icon={<IconMailMenu />}
            hasBorder={false}
            withIcon={false}
          />
          <LinkLine
            text={headerTranslate.mobileApp}
            src={linkDownload}
            icon={<IconMyPref />}
            hasBorder={false}
            withIcon={false}
          />
          {/* <LinkLine
            text="Club privilège"
            src="/accueil/privilege/"
            icon={<IconPrivilege />}
            hasBorder={false}
            withIcon={false}
          /> */}
          <LinkLine
            text={headerTranslate.referral}
            src="/accueil/parrainage/"
            icon={<IconMyFilleuls />}
            hasBorder={false}
            withIcon={false}
          />
        </div>
        <div>
          <LinkLine
            withIcon={false}
            hasBorderTop={true}
            hasBorder={false}
            text={headerTranslate.disconnect}
            icon={<Logout />}
            onClick={() => {
              logout(apolloClient)
                .then((data) => {
                  if (data) {
                    const payload = {
                      jwt: data.logout.jwt,
                      sessionId: data.logout.sessionId,
                      member: data.logout.member,
                    };
                    if (!!data) {
                      setAuth(payload);
                      refetch();
                      window.location.href = '/';
                    }
                  }
                })
                .catch((err) => {
                  window.location.href = '/';
                });
            }}
          />
        </div>
      </LinksContainer>
    </>
  );
};
